import { useContext } from 'react'
import PropTypes from 'prop-types'

import { combineName, finalInactiveSensors } from '../../../../shared/format'
import { showTargetValue } from '../../../../helper/ShowData'

import { SystemContext } from '../../../../shared/context'

const BackButton = ({ device }) => {
	const { systemJson } = useContext(SystemContext)
	const attributes = device?.attributes || null
	const isIoModule = device?.isIoModule

	const targetThreshold = systemJson.temperatureThresholds.find(
		({ place }) => place === attributes?.installation_place
	)

	const targetValue = isIoModule ? '' : showTargetValue(targetThreshold)
	const isInactiveSensors =
		!isIoModule &&
		(attributes?.alarm_active !== '1' ||
			finalInactiveSensors(systemJson.temperatureThresholds, attributes))

	const inactiveAlarming = 'Inaktive Alarmüberwachung'

	return (
		<div className="flex flex-col justify-center h-full ml-1">
			<div
				className={
					'max-w-xs overflow-hidden truncate font-semibold overflow-ellipsis' +
					(isIoModule && attributes?.alarm_active !== '1' ? ' text-gray-400' : '')
				}
			>
				{isIoModule ? device?.filter || 'Alarm-Modul' : combineName(attributes)}
			</div>
			{!isIoModule && (
				<div className="flex items-center max-w-xs italic text-xss">
					<span>{targetValue}</span>
				</div>
			)}
			{isInactiveSensors && (
				<div className="flex items-center max-w-xs italic text-xss">
					<span>{inactiveAlarming}</span>
				</div>
			)}
		</div>
	)
}

BackButton.propTypes = {
	device: PropTypes.shape({
		attributes: PropTypes.object,
		filter: PropTypes.string,
		isIoModule: PropTypes.bool,
	}),
}

export default BackButton
